export const BUTTON_LOGO_BBS = (props) => {

	let svgWidth = props.svgWidth || "100%";
	let svgHeight = props.svgHeight || "100%";
	let svgViewBox = props.svgViewBox || "0 0 720 504";
	let svgPreserveAspectRatio = props.svgPreserveAspectRatio || "none";
	let svgStyle = props.svgStyle || {background:"transparent"};


	return(
		<div>
		<svg xmlns="http://www.w3.org/2000/svg"
			width={svgWidth}
			height={svgHeight}
			viewBox={svgViewBox}
			preserveAspectRatio={svgPreserveAspectRatio}
			style={svgStyle}
		>

     
        


{/*Logo*/}

    <path 
        fill="rgb(0,0,0)" 
        fillRule="evenodd"
        clipRule="evenodd"
        d="M307.973,196.607l4.199-12.548h88.254c17.561,0,26.202,0,32.354,14.274	c9.983-13.432,23.107-16.394,40.831-16.392c12.012,0.002,26.721,0,35.647,0c17.833,0,33.663,0,41.901,16.392 c15.668,0,23.704,11.136,24.841,24.838c0,8.893-2.871,17.445-5.283,25.896l-16.383-0.527c16.912,15.854,19.023,31.18,2.11,56.018 c-8.351,11.703-23.02,17.499-37.188,17.499h-41.419c-15.408,0-36.455,0-45.058-13.798c-11.607,11.59-25.645,12.676-41.567,12.676 l-95.316,0.006l1.586-5.812c-10.042,5.812-22.53,5.806-33.696,5.806h-96.052L144,305.137l45.269-121.077h86.361 C290.846,184.06,301.677,184.06,307.973,196.607L307.973,196.607z M320.303,270.725h52.895c7.115,0,10.412-4.332,12.153-8.973 c1.584-4.227,1.056-6.87-1.586-7.396c-1.058-0.531-6.537-0.546-17.637-0.546l-40.166,0.001L320.303,270.725L320.303,270.725z M332.853,233.216h47.886c7.115,0,10.413-4.154,12.153-8.604c1.585-4.054,1.057-6.588-1.586-7.094	c-1.058-0.51-6.536-0.522-17.636-0.522h-35.39L332.853,233.216L332.853,233.216z M193.714,270.725h53.563 c7.115,0,10.412-4.332,12.153-8.973c1.584-4.227,1.056-6.87-1.587-7.396c-1.057-0.531-6.536-0.546-17.636-0.546h-40.17 L193.714,270.725L193.714,270.725z M157.65,296.104c22.197,0,45.232,0,67.43,0c14.118,0,39.107,3.157,49.678-9.514	c3.697-3.701,6.868-10.04,10.04-19.026c3.446-11.489,5.286-21.533-7.927-24.837c5.283-1.057,9.513-3.7,12.154-7.399	c3.172-3.17,5.813-8.455,7.93-15.855c2.111-6.341,3.169-11.098,3.169-14.269c0-3.699-1.058-6.343-3.169-7.927 c-2.116-2.114-5.813-3.172-11.629-3.7c-2.642,0-11.099,0-24.84,0l-64.499-0.011L157.65,296.104L157.65,296.104z M207.737,233.216 h48.559c7.115,0,10.412-4.154,12.153-8.604c1.584-4.054,1.057-6.588-1.586-7.094c-1.057-0.51-6.537-0.522-17.637-0.522h-35.424 L207.737,233.216L207.737,233.216z M285.326,296.104l76.375,0.001c15.563,0,32.44-0.411,39.807-9.206	c7.365-8.793,6.957-10.879,9.601-19.334c3.171-11.098,3.171-17.967-0.529-21.666c-1.585-1.057-4.228-2.643-7.926-3.171 c5.282-1.586,8.983-4.229,11.626-7.399c3.17-3.699,5.813-8.983,7.929-16.383c1.585-5.813,2.111-10.57,2.111-14.271 c0-9.251-8.188-11.107-15.881-11.107l-89.297-0.001L285.326,296.104L285.326,296.104z M419.383,261.249
		c-2.651,8.956-7.206,24.544,0.185,30.497c7.278,5.861,33.26,5.988,44.512,5.988h19.278c16.822,0,33.45-1.383,41.375-12.227
		c3.72-5.315,6.91-12.225,9.036-22.322c2.126-7.445,2.657-13.289,2.657-17.543c-1.287-9.008-7.953-11.902-15.947-13.287
		c-5.262-0.91-14.881-1.107-29.769-1.595c-17.537-0.575-27.715-0.826-29.763-1.595c-2.226-0.834-3.188-3.189-2.126-6.91
		c1.062-3.719,3.084-6.158,5.846-6.91c3.119-0.85,11.427-1.063,22.324-1.063c10.896,0,16.438,0.381,19.665,0.531
		c8.088,0.381,7.679,2.91,6.378,9.382h27.798l1.373-4.636c2.848-9.613,2.193-15.91,0.067-19.629	c-2.128-3.723-7.476-6.172-15.414-7.441c-5.353-0.856-14.884-1.595-28.172-1.595c-19.138,0-31.924,0.771-38.804,1.595 c-6.419,0.77-11.583,3.835-15.414,7.441c-5.207,4.9-10.284,12.707-13.292,23.919c-2.84,10.583-2.962,17.97-1.063,22.325 c3.169,7.264,15.342,7.971,21.792,7.971l44.652,2.129c6.931,0.328,11.722,0.771,9.568,7.974c-1.584,6.34-5.459,9.227-11.806,9.227	H452.13c-4.744,0-6.358-5.759-4.443-12.227H419.383L419.383,261.249z"
    />
    





    

		</svg>
		</div>

	);//return
}